/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IServerParent } from '../../core/models/common/IServerParent';
import { Server } from '../../core/models/common/Server';

/**
 * A command used to create a new server in a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewServerCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _server : any;

    public _serverExisted : boolean;

    public constructor(parent? : any, server? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IServerParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IServerParent") >= 0)) || parent === null) && ((server != null && server instanceof <any>Server) || server === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._server===undefined) this._server = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._server===undefined) this._server = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._server = Library.writeNode(server);
            })();
        } else if(parent === undefined && server === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._server===undefined) this._server = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._server===undefined) this._server = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewServerCommand] Executing.");
        let parent : IServerParent = <IServerParent><any>document;
        if(!this.isNullOrUndefined(this._parentPath)) {
            parent = <IServerParent><any>this._parentPath.resolve(document);
        }
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let servers : Array<Server> = parent.getServers();
        if(this.isNullOrUndefined(servers)) {
            servers = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        let server : Server = <Server>parent.createServer();
        Library.readNode(this._server, server);
        if(this.serverAlreadyExists(parent, server)) {
            this._serverExisted = true;
            return;
        } else {
            /* add */(servers.push(server)>0);
            this._serverExisted = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewServerCommand] Reverting.");
        if(this._serverExisted) {
            return;
        }
        let parent : IServerParent = <IServerParent><any>document;
        if(ModelUtils.isDefined(this._parentPath)) {
            parent = <IServerParent><any>this._parentPath.resolve(document);
        }
        if(this.isNullOrUndefined(parent) || this.isNullOrUndefined(parent.getServers())) {
            return;
        }
        let servers : Array<Server> = parent.getServers();
        let serverUrl : string = JsonCompat.getPropertyString(this._server, Constants.PROP_URL);
        let server : Server = parent.getServer(serverUrl);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        /* remove */servers.splice(servers.indexOf(server), 1)[0];
        if(/* size */(<number>servers.length) === 0) {
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, null);
        }
    }

    /**
     * Returns true if a server with the same url already exists in the parent.
     * @param {*} parent
     * @param {Server} server
     * @return {boolean}
     * @private
     */
    /*private*/ serverAlreadyExists(parent : IServerParent, server : Server) : boolean {
        return ModelUtils.isDefined(parent.getServer(server.url));
    }
}
NewServerCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewServerCommand";
NewServerCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

